<template>
    <div class="vertical-flow">
        <div class="listing-header mb-4" v-if="!cantEdit">
            <div class="title-breadcrumb"/>
            <div class="header-buttons">
                <button
                    v-if="(!isUpdate && permissao.create) || (isUpdate && permissao.update)" 
                    @click="showModal"
                    :disabled="isSaving"
                    class="save-btn"
                    type="button"
                >
                    {{ $t("adicionar") }} 
                    <button-loader :isSaving="isSaving" />
                </button>
            </div>
        </div>

        <div class="registry-wrapper">
            <container-loader v-if="isLoading && !$store.getters.isLoading" />
            <empty-table-message v-if="isEmpty" />
            <b-table
                v-else
                :data="fenologiaitens"
                class="data-table"
                backend-sorting
            >
                <b-table-column
                    v-for="(f, i) in fields"
                    :key="i"
                    :field="f.key"
                    :label="f.key != 'excluir' ? $t(f.key) : ''"
                    :width="f.width"
                    :class="{
                        'excluir-field': f.key == 'excluir'
                    }"
                >
                    <template v-slot="props">
                        <div v-if="f.key == 'data-hora'">
                            {{ props.row['dataHora'] | moment('DD/MM/YYYY HH:mm:ss') }}
                        </div>
                        <div v-else-if="f.key == 'excluir' && permissao.delete && fenologia.situacao === 4 && !cantEdit">
                            <b-button  type="is-danger"
                                @click="promptDeletarFaseFenologica(props.row)"
                                icon-right="delete" 
                                position="is-left"
                                v-tippy 
                                :title="$t('excluir')"
                            />
                        </div>
                        <div v-else-if="f.key == 'codigo'">
                            {{ props.row['idAgroFaseFenologicaORegItemErp'] }}
                        </div>
                        <div v-else-if="f.key == 'fasefenologica'">
                            {{ props.row['faseFenologica'].descricao }}
                        </div>
                        <div v-else>
                            {{ props.row[f.key] }}
                        </div>
                    </template>
                </b-table-column>
            </b-table>
            <PaginationViewer
                class="mb-0"
                :resetPagination="pagination.resetPagination"
                :totalItems="pagination.totalRows"
                :perPageOptions="pagination.perPageOptions"
                :optionStarted="pagination.optionStarted"
                @change="updatePagination"
            />

            <!-- MODAL PARA ADICIONAR FASE FENOLOGICA -->
            <b-modal :active.sync="showModalAssociacao">
                <div class="bg">
                <FaseFenologicaModal
                    @fecharModal="fecharModal"
                    :fenologia="fenologia"
                />
                </div>
            </b-modal>
        </div>
    </div>  
</template>


<script>
import AgroFenologiaItemService from "@/services/agro/fenologia/AgroFenologiaItemService";
import FaseFenologicaModal from "@/components/agro/fenologia/abas/modal/FaseFenologicaModal";
import ContainerLoader from "@/components/content/loader/ContainerLoader";

export default {
    components: {
        ContainerLoader,
        FaseFenologicaModal
    },
    props: {
        isUpdate: {
            type: Boolean,
            default: false
        },
        cantEdit: {
            type: Boolean,
            default: false
        },
        fenologia: {
            type: Object,
            default: {}
        },
        fenologiaitens: {
            type: Array,
            default: []
        },
        totalRows: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            permissao: false,
            isSaving: false,
            isEmpty: true,
            isLoading: false,
            service: new AgroFenologiaItemService(this.$http, this.$router),

            // listagem
            fields: [
                { key: "codigo", width: null, sortable: false, sortFn: null },
                { key: "fasefenologica", width: null, sortable: false, sortFn: null },
                { key: "data-hora", width: null, sortable: false, sortFn: null },
                { key: "excluir", width: null, sortable: false, sortFn: null },
            ],
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: 10,
                totalRows: 0,
                currentPage: 1,
            },

            showModalAssociacao: false,
        }
    },
    created() {
        // caso seja update inicia validação de carregamento dos dados
        if(this.isUpdate) this.isLoadingEdit = true;

        setTimeout(() => { 
            this.$emit("isChanged", false);
        }, 1000);

        this.permissao = this.hasPermissionAccess(
            'agro',
            'agro-fenologia',
            'agro-fenologia'
        );
    
        if (
            (!this.isUpdate && !this.permissao.create) || 
            (this.isUpdate && !this.permissao.read)
        ) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'agro-fenologia' },
            });
        } else {
            this.carregarDados(1, false);
        }
    },
    methods: {
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage, true);
        },
        carregarDados(currentPage = 1, emitir = false) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;

            if (this.fenologiaitens.length > 0 && !emitir) {
                this.pagination.totalRows = this.totalRows;
                this.isEmpty = false;
            }

            this.$emit('atualizarItens', { 'pagina': currentPage, 'por-pagina': this.pagination.perPage, done: () => {
                this.isEmpty = this.fenologiaitens.length <= 0;
                this.pagination.totalRows = this.totalRows;
                this.pagination.resetPagination = false;
            } });
        },
        showModal() {
            this.showModalAssociacao = !this.showModalAssociacao;
        },
        fecharModal() {
            this.showModalAssociacao = false;
            this.carregarDados();
        },
        promptDeletarFaseFenologica(row) {
            let message = this.$t("msg-confirmacao-exclusao-n", 
                { n: row['faseFenologica'].descricao }
            );
            this.$root.confirm({
                message: message,
                onConfirm: _ => this.deletarFaseFenologica(row),
            });
        },
        deletarFaseFenologica(item) {
            this.isLoading = true;

            // pega alocalização através do navegador caso esteja liberado
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(this.successPosition, this.errorPosition);
            }

            let fenologiaTemp = Object.assign({}, item);
            fenologiaTemp.situacao = 0;

            this.service.save(fenologiaTemp)
            .then(value => {
                if (value.message == null) {
                    // novo modelo de mensagem dinâmica
                    let msg = this.$t('msg-delete-sucesso-n', { n: this.$t('fasefenologica') });
        
                    this.$root.showMessage('success', msg, true, false);
                }
            })
            .catch((e) => {
                this.$root.showMessage('error', 'msg-erro-load', true);
            })
            .finally(() => {
                this.isLoading = false;
                this.carregarDados(this.pagination.currentPage, true);
            });
        },
        successPosition(position){
            this.fenologia.latitude = (position.coords.latitude)?position.coords.latitude:0;
            this.fenologia.longitude = (position.coords.longitude)?position.coords.longitude:0;
            this.fenologia.lastfix = (position.timestamp)?position.timestamp:null;
            this.fenologia.tipogps = (position.coords.latitude)?1:0;
        },
        errorPosition(e){
            console.error('Geolocation error!', e);
        },
    }
}
</script>
